import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  stadium: null,
  gameDate: null,
  homeKey: null,
  visitKey: null,
  homeAway: null,
  gameTimes: null,
};

// Slice
const gameScheduleSlice = createSlice({
  name: "gameSchedule",
  initialState,
  reducers: {
    getGameScheduleInfo(state) {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    },
    setGameScheduleInfo(state, action) {
      const {
        stadium,
        gameDate,
        homeKey,
        visitKey,
        homeAway,
        gameTimes
      } = action.payload;
      return {
        ...state,
        stadium,
        gameDate,
        homeKey,
        visitKey,
        homeAway,
        gameTimes
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { getGameScheduleInfo, setGameScheduleInfo, fetchDataSuccess, fetchDataFailure } =
gameScheduleSlice.actions;

export default gameScheduleSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });

    const response = yield call(apiService.get, apiUrl, headers);
    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      console.log(response.data)
      const {
        stadium,
        game_date,
        home_key,
        visit_key,
        home_away,
        game_times,
      } = response.data;
      yield put(
        setGameScheduleInfo({
          stadium: stadium,
          gameDate: game_date,
          homeKey: home_key,
          visitKey: visit_key,
          homeAway: home_away,
          gameTimes: game_times
        })
      );
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* gameScheduleSaga() {
  yield takeLatest(getGameScheduleInfo.type, fetchDataSaga);
}
